import { lintWarning } from "./utils";
var linter = function linter(key, value, info) {
  if (typeof value === 'string' && /NaN/g.test(value) || Number.isNaN(value)) {
    lintWarning("Unexpected 'NaN' in property '".concat(key, ": ").concat(value, "'."), info);
  }
};
export default linter;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/cssinjs/es/linters/NaNLinter.js
// module id = 3477
// module chunks = 0